<template>
  <div class="venueAppointment-list">
    <el-table :data="venueAppointmentList" border style="width: 100%" tooltip-effect="dark" class="common-edit-button"
      @selection-change="handleSelectionChange">
      <el-table-column label="#" type="index"> </el-table-column>
      <el-table-column type="selection" width="55"></el-table-column>
      <el-table-column prop="venueName" width="150px" :show-overflow-tooltip="true" label="场馆名称">
      </el-table-column>
      <el-table-column prop="teacherName" width="150px" :show-overflow-tooltip="true" label="申请人姓名">
      </el-table-column>
      <el-table-column width="220px" label="申请时间" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          {{ scope.row.createTime }}
        </template>
      </el-table-column>
      <el-table-column label="使用时间" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          {{ scope.row.startTime }} <b>~</b> {{ scope.row.endTime }}
        </template>
      </el-table-column>
      <!-- <el-table-column label="审批时间" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          {{ scope.row.reviewTime }}
        </template>
      </el-table-column> -->
      <el-table-column label="操作" :width="venueAppointmentStatus !== 0 ? '200px' : '380px'" fixed="right">
        <template slot-scope="scope">
          <div class="operate">
            <!-- 审核 -->
            <el-button type="primary" size="small"
              v-show="scope.row.reviewStatus == 0" @click="showDialog(scope.row.id)"
              v-hasPermi="'sc:subscribe:check'">审核
            </el-button>
            <!-- 详情 -->
            <el-button type="success" size="small" @click="detailClick(scope.row.id)" v-show="scope.row.reviewStatus !== 0 && scope.row.reviewStatus !== 3
              " v-hasPermi="'sc:venueappointment:query'">详情
            </el-button>
            <!-- 修改 -->
            <el-button type="warning" size="small" :disabled="scope.row.teacherId !== user.id" @click="edltClick(scope.row)" v-show="scope.row.reviewStatus == 0"
              v-hasPermi="'sc:venueappointment:edit'">修改
            </el-button>
            <!-- 撤回 -->
            <el-button type="info" size="small" :disabled="scope.row.teacherId !== user.id" @click="revocation(scope.row.requestCode)"
              v-show="scope.row.reviewStatus == 0">撤回
            </el-button>
            <!-- 删除 -->
            <el-button type="danger" size="small" :disabled="scope.row.teacherId !== user.id" @click="delClick(scope.row.id)"
              v-hasPermi="'sc:venueappointment:delete'">删除
            </el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <venueAppointmentEdit :dialogFormVisible.sync="editShow" :venueAppointmentData="venueAppointmentData"
      :publicvenueList="publicvenueList" @edit="edit" v-show="editShow" />
    <venueAppointmentDetail :detailShow.sync="detailShow" :venueAppointmentDetail="venueAppointmentDetail"
      v-if="detailShow" />
    <!-- 审核 -->
    <el-dialog title="审核操作" :visible.sync="dialogFormVisible" v-if="dialogFormVisible" center width="30%">
      <el-form :model="form">
        <el-form-item label="审核操作">
          <el-radio v-model="form.status" label="1">同意</el-radio>
          <el-radio v-model="form.status" label="2">拒绝</el-radio>
        </el-form-item>
        <el-form-item label="预约原因">
          <el-input type="textarea" :rows="2" placeholder="请输入内容" v-model="venueAppointmentDetail.request.reasonRemark"
            :disabled="true">
          </el-input>
        </el-form-item>
        <el-form-item label="审核意见">
          <el-input type="textarea" :rows="2" placeholder="请输入内容" v-model="form.feedback">
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="updateStatus">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import venueAppointmentEdit from "../../components/venueAppointment-edit/venueAppointmentEdit.vue";
import venueAppointmentDetail from "../venueAppointment-detail/venueAppointmentDetail.vue";
export default {
  name: "",
  components: {
    venueAppointmentEdit,
    venueAppointmentDetail,
  },
  props: {
    venueAppointmentList: {
      type: Array,
      default: () => {
        return [];
      },
    },
    venueAppointmentStatus: {
      type: Number,
      require: true,
    },
    publicvenueList: {
      type: Array,
    },
  },
  data() {
    return {
      editShow: false,
      detailShow: false,
      venueAppointmentData: null,
      venueAppointmentDetail: null,
      dialogFormVisible: false,
      form: {
        status: "1",
        feedback: "",
      },
    };
  },
  created() { },
  methods: {
    // 审核
    updateStatus() {
      let { status, feedback } = this.form;
      let { reviewRank, requestCode } = this.venueAppointmentDetail;
      // console.log(id,reviewStatus);
      this.post(this.$url.schoolReviewRequest, {
        requestCode,
        status,
        reviewRank,
        feedback,
      })
        .then((res) => {
          // console.log(res);
          if (res.code == 200) {
            this.$emit("edit", requestCode);
            this.$message.success("操作成功");
            this.dialogFormVisible = false;
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((res) => {
          this.$message.error("操作失败，请稍后重试");
        });
    },
    showDialog(id) {
      this.form = {
        status: "1",
        feedback: "",
      };
      this.get(this.$url.getVenueappointmentDetail + "/" + id).then((res) => {
        // console.log("场馆预约详细信息==>", res);
        this.venueAppointmentDetail = res.data;
        this.dialogFormVisible = true;
      });
    },
    handleSelectionChange(val) {
      // console.log(val);
      this.selectList = val;
      let list = [];
      this.selectList.forEach((item) => {
        list.push(item.id);
      });
      this.$emit("multipleDelete", list);
    },
    edltClick(item) {
      // console.log(item);
      this.get(this.$url.getVenueappointmentDetail + "/" + item.id).then(
        (res) => {
          // console.log(res);
          if (!res.data.request) return this.$message.error("出现异常");
          this.venueAppointmentData = res.data;
          this.editShow = true;
        }
      );
    },
    detailClick(id) {
      this.get(this.$url.getVenueappointmentDetail + "/" + id).then((res) => {
        // console.log(res);
        if (res.data.reviewList.length == 0)
          return this.$message.error("出现异常");
        this.detailShow = true;
        this.venueAppointmentDetail = res.data;
      });
      // console.log(this.detailShow);
    },
    edit(e) {
      this.$emit("edit", e);
    },
    delClick(id) {
      this.$confirm("是否删除该场馆预约?", "删除预约", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        confirmButtonClass: "confirm",
      })
        .then(() => {
          let list = [];
          list.push(id);
          this.$emit("delClick", list);
        })
        .catch(() => { });
    },
    revocation(requestCode) {
      this.$confirm("是否撤销该场馆预约?", "撤销预约", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        confirmButtonClass: "confirm",
      })
        .then(() => {
          this.get(this.$url.schoolRequestRevocation, {
            requestCode,
          }).then((res) => {
            if (res.code !== 200) return this.$message.error(res.msg);
            this.$emit("revocation", requestCode);
            this.$message.success("操作成功");
          });
        })
        .catch(() => { });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./venueAppointment-list.scss";
</style>
